import { useState, useEffect } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { csvUrl, currencyFormatter, getData } from '../CustomUtils'
import { PAID_INDEMNITY_QUERY } from '../../../graphql.js'
import ParameterValues from '../ParameterValues.js'
import ResultsGrid from '../ResultsGrid.js'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ReportFooter from '../ReportFooter.js'
import TotalsRow from '../TotalsRow.js'

const PAID_INDEMNITY = gql(PAID_INDEMNITY_QUERY)

export default function PaidIndemnity() {
  const location = useLocation()
  console.log('PaidIndemnity rendered', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [searchParams] = useSearchParams()
  const inputs = JSON.parse(searchParams.get('inputs'))
  const reportVersion = inputs.reportVersion
  let totalColumn = reportVersion === '2' ? 11 : 12

  useEffect(() => {
    getData(location, PAID_INDEMNITY, 'paidIndemnity', setResults, setGraphQLErrors)
  }, [location])

  let totalSettlementAmount = 0

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    for (let i = 0; i < results.reportData.length; i++) {
      results.reportData[i][7] = results.reportData[i][7].replaceAll('&nbsp;', ' ')
    }
    let resultRows = ResultsGrid(results, 0, null, null, null, totalColumn, currencyFormatter(), number => totalSettlementAmount += parseFloat(number))
    const parameterValues = ParameterValues(results)
    delete parameterValues[parameterValues.length-1] //removes report date from parameter values
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/paidIndemnity/paid_indemnity', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Paid Indemnity Report'} parameterValues={parameterValues} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
            <TotalsRow columnNumber={totalColumn} total={totalSettlementAmount} />
          </tbody>
        </Table>
        <ReportFooter>CONFIDENTIAL -- SUBJECT TO PROTECTIVE ORDER -- FOSTER WHEELER LITIGATION.</ReportFooter>
      </div>
    )
  }
}